export default {
  init() {
    // JavaScript to be fired on all pages
    $('#toTop').on('click', function(event){
      event.preventDefault();
      $('html, body').animate({
        scrollTop: 0,
      }, 500);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// /Users/jrh/Development/@4site/clk/clk-site/wp-content/themes/4site/resources/assets/scripts/routes/common.js